import React, { useState, useRef, useEffect, useMemo, useCallback } from 'react';
import { AgGridReact } from 'ag-grid-react';
import { Paper, Grid, Box, Button, Tooltip, IconButton, Accordion, AccordionSummary, AccordionDetails, Dialog, DialogTitle, DialogContent, DialogContentText, DialogActions, TextField } from '@mui/material';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import ContentCopyIcon from '@mui/icons-material/ContentCopy';
import CircleIcon from '@mui/icons-material/Circle';
import Typography from '@mui/material/Typography';
import api from '../security/AxiosConfig';
import { makeStyles } from '@mui/styles';
import Controls from '../components/controls/Controls';
import * as MyCollections from "../services/MyCollections";
import { useTheme } from '@mui/material/styles';
import useMediaQuery from '@mui/material/useMediaQuery';
import OtherDocumentsDialog from '../components/OtherDocumentsDialog';
import AdditionalServicesDialog from '../components/AdditionalServicesDialog'
import { urlAccountingStatements, urlAccountants, urlAccountingSettlement, urlDocumentType, urlServiceType, urlFiles, urlLogActivity, urlNotifications, urlClients } from '../config';
import { fetchData } from '../services/ApiServices';
import ConfirmDialog from '../components/ConfirmDialog';
import { useLocation } from 'react-router-dom';
import BtnCellRenderer from '../components/controls/BtnCellRenderer';
import { useAuthStore } from '../store/authStore';
import ApproveForPaymentDialog from '../components/ApproveForPaymentDialog';
import * as CommonFunctions from '../services/CommonFunctions';
import { logActionType } from "../services/MyCollections";
import { logActivity } from '../services/ApiServices';
import OverdueDocumentsDialog from '../components/OverdueDocumentsDialog';
import CustomTooltip from '../components/CustomTooltip';
import UploadCorrectionDialog from '../components/UploadCorrectionDialog';
import HeaderComponentForStatement from '../components/HeaderComponentForStatement';
import ActionButtons from '../components/ActionButtons';
import HeaderComponent from '../components/HeaderComponent';
import { CustomAlert } from '../components/CustomAlert';
import { useThemeContext } from '../components/contexts/ThemeContext';


const useStyles = makeStyles(theme => ({
    pageContent: {
        marginTop: 20
    },
}))



const CompanyRenderer = (props) => {
    const { clientName, vatStatus, isBottomTable } = props.data || {};
    const isDark = props.context?.darkTheme || false;

    if (clientName === "BONUS") {
        return (
            <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'flex-start', height: '100%' }}>
                <span style={{ color: '#0daf0b', fontWeight: 'bold' }}>🏆 {clientName}</span>
            </div>
        );
    }
    if (clientName === "BONUS ŚWIĄTECZNY") {
        return (
            <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'flex-start', height: '100%' }}>
                <span style={{ color: '#0daf0b', fontWeight: 'bold' }}>🎄 {clientName}</span>
            </div>
        );
    }
    if (clientName === "ZWROT BLOKADY") {
        return (
            <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'flex-start', height: '100%' }}>
                <span style={{ color: '#0daf0b', fontWeight: 'bold' }}>🔓 {clientName}</span>
            </div>
        );
    }
    if (clientName === "ANTYBONUS") {
        return (
            <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'flex-start', height: '100%' }}>
                <span style={{ color: 'red', fontWeight: 'bold' }}>⛔ {clientName}</span>
            </div>
        );
    }
    if (clientName === "BLOKADA") {
        return (
            <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'flex-start', height: '100%' }}>
                <span style={{ color: 'red', fontWeight: 'bold' }}>🔒 {clientName}</span>
            </div>
        );
    }
    if (clientName === "DODATKOWA OPŁATA") {
        return (
            <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'flex-start', height: '100%' }}>
                <span style={{ color: 'red', fontWeight: 'bold' }}>💸 {clientName}</span>
            </div>
        );
    }
    if (clientName && clientName.includes('| Razem')) {
        return (
            <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'flex-start', height: '100%' }}>
                <span style={{ fontWeight: 'bold', color: isBottomTable && isDark ? 'white' : 'inherit' }}>{clientName}</span>
            </div>
        );
    }

    let vatIcon = null;
    if (vatStatus === "CZYNNY") {
        vatIcon = <Tooltip title="VAT Czynny"><CircleIcon sx={{ color: '#10b981', fontSize: '12px' }} /></Tooltip>;
    } else if (vatStatus === "ZWOLNIONY") {
        vatIcon = <Tooltip title="VAT Zwolniony"><CircleIcon sx={{ color: '#3b82f6', fontSize: '12px' }} /></Tooltip>;
    } else if (vatStatus === "NIEZAREJESTROWANY") {
        vatIcon = <Tooltip title="VAT Niezarejestrowany"><CircleIcon sx={{ color: '#f59e0b', fontSize: '12px' }} /></Tooltip>;
    }

    let color = isDark ? '#f8fafc' : '#0f172a';
    if (isBottomTable && isDark) color = 'white';

    return (
        <div style={{ display: 'flex', alignItems: 'center', height: '100%', gap: '8px', justifyContent: 'flex-start' }}>
            {vatIcon}
            <span style={{ fontWeight: '700', color: color }}>
                {clientName}
            </span>
        </div>
    );
};

const CopyableTextRenderer = (props) => {
    const text = props.value;
    const clientName = props.data?.clientName;
    const isDark = props.context?.darkTheme || false;

    if (clientName === "BONUS" || clientName === "ANTYBONUS" || clientName === "BONUS ŚWIĄTECZNY" || clientName === "BLOKADA" || clientName === "ZWROT BLOKADY" || clientName === "DODATKOWA OPŁATA") {
        return null;
    }

    if (!text || text === 'brak') {
        return (
            <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'flex-start', height: '100%' }}>
                <span style={{ color: isDark ? '#94a3b8' : '#64748b' }}>brak</span>
            </div>
        );
    }

    const handleCopy = () => {
        navigator.clipboard.writeText(text);
    };

    let iconColor = isDark ? '#c084fc' : '#8b5cf6';
    const textColor = isDark ? '#e2e8f0' : '#334155';

    return (
        <div style={{ display: 'flex', alignItems: 'center', height: '100%', justifyContent: 'space-between', paddingRight: '8px' }}>
            <div style={{ display: 'flex', alignItems: 'center' }}>
                <span style={{ marginRight: '6px', fontSize: '10px', fontWeight: 'bold', color: iconColor }}>NIP</span>
                <span style={{ color: textColor }}>{text}</span>
            </div>
            <Tooltip title="Kopiuj">
                <IconButton
                    size="small"
                    onClick={handleCopy}
                    sx={{ padding: '2px', color: isDark ? '#64748b' : '#94a3b8', '&:hover': { color: textColor } }}
                >
                    <ContentCopyIcon sx={{ fontSize: '14px' }} />
                </IconButton>
            </Tooltip>
        </div>
    );
};

const TurnoverCellRenderer = (props) => {
    const range = props.value;
    const data = props.data;
    const isDark = props.context?.darkTheme || false;
    const isCost = props.colDef?.field?.includes('cost') || false;

    if (!range || range === 'brak' || range === '') {
        return (
            <div style={{ display: 'flex', alignItems: 'center', height: '100%', color: isDark ? '#64748b' : '#94a3b8', fontSize: '11px' }}>
                -
            </div>
        );
    }

    // Color theme based on range
    let bg = isDark ? 'rgba(59, 130, 246, 0.2)' : '#e0f2fe';
    let textCol = isDark ? '#60a5fa' : '#0369a1';
    let borderCol = isDark ? 'rgba(59, 130, 246, 0.4)' : '#bae6fd';

    if (range.includes('do 50')) {
        bg = isDark ? 'rgba(100, 116, 139, 0.25)' : '#f1f5f9';
        textCol = isDark ? '#94a3b8' : '#475569';
        borderCol = isDark ? 'rgba(148, 163, 184, 0.3)' : '#cbd5e1';
    } else if (range.includes('50 do 240')) {
        bg = isDark ? 'rgba(16, 185, 129, 0.2)' : '#dcfce7';
        textCol = isDark ? '#34d399' : '#15803d';
        borderCol = isDark ? 'rgba(16, 185, 129, 0.4)' : '#86efac';
    } else if (range.includes('240 do 500')) {
        bg = isDark ? 'rgba(245, 158, 11, 0.2)' : '#fef3c7';
        textCol = isDark ? '#fbbf24' : '#b45309';
        borderCol = isDark ? 'rgba(245, 158, 11, 0.4)' : '#fde68a';
    } else if (range.includes('500 do 1 mln')) {
        bg = isDark ? 'rgba(236, 72, 153, 0.2)' : '#fce7f3';
        textCol = isDark ? '#f472b6' : '#be185d';
        borderCol = isDark ? 'rgba(236, 72, 153, 0.4)' : '#fbcfe8';
    } else if (range.includes('powyżej 1 mln')) {
        bg = isDark ? 'rgba(168, 85, 247, 0.2)' : '#f3e8ff';
        textCol = isDark ? '#c084fc' : '#7e22ce';
        borderCol = isDark ? 'rgba(168, 85, 247, 0.4)' : '#d8b4fe';
    }

    const cumulativeAmount = isCost ? data?.costTurnoverCumulative : data?.salesTurnoverCumulative;
    const monthAmount = isCost ? data?.costTurnover : data?.salesTurnover;

    const formatMoney = (val) => {
        if (val === null || val === undefined) return '-';
        return Number(val).toLocaleString('pl-PL', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) + ' zł';
    };

    const tooltipContent = (
        <div style={{ fontSize: '11px', lineHeight: '1.4', padding: '3px' }}>
            <div style={{ fontWeight: 'bold', marginBottom: '4px', borderBottom: '1px solid rgba(255,255,255,0.2)', paddingBottom: '2px' }}>
                {isCost ? '🛒 Koszty ze Scanye (netto)' : '📈 Sprzedaż ze Scanye (netto)'}
            </div>
            <div>Przedział: <strong>{range}</strong></div>
            <div>Skumulowane (do poprz. m-ca): <strong>{formatMoney(cumulativeAmount)} netto</strong></div>
            <div>Wartość w poprz. m-cu: <strong>{formatMoney(monthAmount)} netto</strong></div>
            {!isCost && data?.needsVatRegistration && (
                <div style={{ marginTop: '6px', paddingTop: '4px', borderTop: '1px solid rgba(255,255,255,0.2)', color: data?.vatAlertStatus === 'EXCEEDED' ? '#f87171' : '#fbbf24', fontWeight: 'bold' }}>
                    {data?.vatAlertStatus === 'EXCEEDED' ? '🚨 Przekroczono 240 tyś zł — wymagana rejestracja do VAT!' : '⚠️ Blisko limitu 240 tyś zł — uwaga na VAT!'}
                </div>
            )}
        </div>
    );

    const needsVat = !isCost && Boolean(data?.needsVatRegistration);
    const vatAlertStatus = data?.vatAlertStatus;

    const rangePill = (
        <span style={{
            backgroundColor: bg,
            color: textCol,
            border: `1px solid ${borderCol}`,
            padding: '2px 8px',
            borderRadius: '12px',
            fontSize: '11px',
            fontWeight: '600',
            whiteSpace: 'nowrap',
            cursor: 'help',
            flexShrink: 0
        }}>
            {range}
        </span>
    );

    if (needsVat) {
        return (
            <Tooltip title={tooltipContent} arrow placement="top">
                <div style={{ display: 'flex', alignItems: 'center', height: '100%', gap: '6px', cursor: 'help' }}>
                    {rangePill}
                    <span style={{
                        fontSize: '13px',
                        lineHeight: 1,
                        display: 'inline-flex',
                        alignItems: 'center',
                        flexShrink: 0
                    }}>
                        {vatAlertStatus === 'EXCEEDED' ? '🚨' : '⚠️'}
                    </span>
                </div>
            </Tooltip>
        );
    }

    return (
        <div style={{ display: 'flex', alignItems: 'center', height: '100%' }}>
            <Tooltip title={tooltipContent} arrow placement="top">
                {rangePill}
            </Tooltip>
        </div>
    );
};

const MonthlyStatement = () => {

    const gridRef = useRef(); // Optional - for accessing Grid's API
    const bottomGrid = useRef();
    const location = useLocation();
    const { roles: roles } = useAuthStore();
    const canViewTurnover = Boolean(
        roles?.some(role => role && (role.toUpperCase() === 'ADMIN' || role.toUpperCase() === 'ADMIN_SUPERVISOR'))
    );

    const token = useAuthStore().token;
    const userName = useAuthStore().fullName;
    const contactId = useAuthStore().contactId;
    const queryParams = new URLSearchParams(location.search);
    const urlMonth = queryParams.get('month');
    const urlYear = queryParams.get('year');
    const urlAccountantId = queryParams.get('accountantId');
    const [gridApi, setGridApi] = useState(null);
    const [tableData, setTableData] = useState([]);
    const [documentType, setDocumentType] = useState(null);
    const [tariffData, setTariffData] = useState(null);
    const [gridColumnApi, setGridColumnApi] = useState(null);
    const [selectedMonth, setSelectedMonth] = useState(
        urlMonth !== null ? urlMonth : String(parseInt(CommonFunctions.getMonthForSelect(), 10)));
    const [selectedYear, setSelectedYear] = useState(
        urlYear !== null ? urlYear : String(parseInt(CommonFunctions.getYearForSelect(), 10)));
    const [unlockedMonthLimit, setUnlockedMonthLimit] = useState(() => {
        const defaultLim = parseInt(CommonFunctions.getMonthForSelect(urlYear !== null ? urlYear : String(parseInt(CommonFunctions.getYearForSelect(), 10))), 10);
        const initialMonth = urlMonth !== null ? parseInt(urlMonth, 10) : parseInt(CommonFunctions.getMonthForSelect(), 10);
        return Math.max(defaultLim, initialMonth);
    });
    const undoRedoCellEditing = true;
    const undoRedoCellEditingLimit = 20;
    const theme = useTheme();
    const isDesktop = useMediaQuery(theme.breakpoints.up('sm'));
    const [url, setUrl] = useState('');
    const [openOtherDocumentsDialog, setOpenOtherDocumentsDialog] = useState(false);
    const [openOverdueDocumentsDialog, setOpenOverdueDocumentsDialog] = useState(false);
    const [openAdditionalServicesDialog, setOpenAdditionalServicesDialog] = useState(false);
    const [formData, setFormData] = useState([]);
    const [additionalServicesFormData, setAdditionalServicesData] = useState([]);
    const [serviceType, setServiceType] = useState(null);
    const [accountants, setAccountants] = useState([]);
    const [selectedAccountant, setSelectedAccountant] = useState(urlAccountantId !== null ? urlAccountantId : null);
    const [openConfirmDialog, setOpenConfirmDialog] = useState(false);
    const [isSimple, setIsSimple] = useState(false);
    const [accountingSettlement, setAccountingSettlement] = useState([]);
    const [confirmDialogTitle, setConfirmDialogTitle] = useState("");
    const [confirmDialogMessage, setConfirmDialogMessage] = useState("");
    const [actionType, setActionType] = useState("")
    const classes = useStyles();
    const [currentDate, setCurrentDate] = useState(CommonFunctions.getCurrentDate());
    const [openApprovePaymentDialog, setOpenApprovePaymentDialog] = useState(false);
    const activeClients = tableData.filter(item => item.clientName !== "ANTYBONUS" && item.clientName !== "BONUS" && item.clientName !== "BONUS ŚWIĄTECZNY" && item.clientName !== "BLOKADA" && item.clientName !== "ZWROT BLOKADY" && item.clientName !== "DODATKOWA OPŁATA");
    const [popupEnabled, setPopupEnabled] = useState(false);
    const [clients, setClients] = useState([]);
    const [isModified, setIsModified] = useState(false);
    const [isStatementEdited, setIsStatementEdited] = useState(false);
    const [oldOtherDocuments, setOldOtherDocuments] = useState([]);
    const [oldServices, setOldServices] = useState([]);
    const { mode, toggleTheme } = useThemeContext();
    const darkTheme = mode === 'dark';

    const [openAddBlockDialog, setOpenAddBlockDialog] = useState(false);
    const [confirmAddBlockOpen, setConfirmAddBlockOpen] = useState(false);
    const [blockAmount, setBlockAmount] = useState('');
    const [blockDescription, setBlockDescription] = useState('');

    const [openAdditionalFeeDialog, setOpenAdditionalFeeDialog] = useState(false);
    const [confirmAdditionalFeeOpen, setConfirmAdditionalFeeOpen] = useState(false);
    const [additionalFeeAmount, setAdditionalFeeAmount] = useState('');
    const [additionalFeeId, setAdditionalFeeId] = useState(null);

    const [isTableLoading, setIsTableLoading] = useState(true);

    const isAdminOrSupervisor =
        roles?.includes('ADMIN') ||
        roles?.includes('ADMIN_SUPERVISOR') ||
        roles?.includes('SUPERVISOR') ||
        roles?.includes('SUPERVISOR_ACCOUNTANT') ||
        roles?.includes('MANAGER');

    const hasExistingBlock = tableData.some(row => row.clientName === "BLOKADA");
    const isOwnStatement = roles?.includes('SUPERVISOR_ACCOUNTANT') && Number(contactId) === Number(selectedAccountant);
    const canAddBlock = isAdminOrSupervisor
        && selectedAccountant
        && Number(selectedAccountant) !== 0
        && accountingSettlement?.statementFinished
        && !accountingSettlement?.payed
        && !isTableLoading
        && !hasExistingBlock
        && !isOwnStatement;

    const canAddAdditionalFee = isAdminOrSupervisor
        && selectedAccountant
        && Number(selectedAccountant) !== 0
        && accountingSettlement?.statementFinished
        && !accountingSettlement?.payed
        && !isTableLoading
        && !isOwnStatement;


    const onGridReady = (params) => {
        setGridApi(params.api);
        setGridColumnApi(params.columnApi);
    };

    useEffect(() => {
        if (roles?.includes('SUPERVISOR') || roles?.includes('SUPERVISOR_ACCOUNTANT')) {
            let isAccountant = roles?.includes('SUPERVISOR_ACCOUNTANT');
            fetchData(urlAccountants + `/allForSelectBySupervisorId?supervisorId=${contactId}&isAccountant=${isAccountant}&month=${selectedMonth}&year=${selectedYear}`, mapToSelect, (data) => {
                setAccountants(data);
                if (selectedAccountant === null && data.length > 0 && !isAccountant) {
                    setSelectedAccountant(data[0].id);
                }
                else if (selectedAccountant !== null) {
                    setSelectedAccountant(selectedAccountant);
                }
                else {
                    setSelectedAccountant(contactId);
                }
            }, null, token);
        }
        else if (roles?.includes('ADMIN') || roles?.includes('ADMIN_SUPERVISOR') || roles?.includes('ACCOUNT_MANAGER') || roles?.includes('MANAGER')) {
            fetchData(
                urlAccountants + `/allForSelectByMonthAndYear?month=${selectedMonth}&year=${selectedYear}`,
                mapToSelect,
                (data) => {
                    const extendedData = [...data, { id: 0, title: "Wszyscy Księgowi" }];
                    setAccountants(extendedData);

                    if (selectedAccountant === null && extendedData.length > 0) {
                        setSelectedAccountant(extendedData[0].id);
                    }
                },
                null,
                token
            );
        }
        else if (roles?.includes('ACCOUNTANT') || roles?.includes('CHIEF_ACCOUNTANT')) {
            setSelectedAccountant(contactId);
        }
        else {
            setSelectedAccountant("");
        }
        getDocumentType(selectedYear, selectedMonth);
        getServiceType();
    }, [selectedMonth, selectedYear]);

    useEffect(() => {
        if (selectedAccountant !== null) {
            fetchAccountingSettlement(selectedMonth, selectedYear, selectedAccountant);
            fetchAccountingStatements(selectedMonth, selectedYear, selectedAccountant);
        }
        getServiceType();
    }, [selectedAccountant, selectedMonth, selectedYear]);

    useEffect(() => {
        const defaultLim = parseInt(CommonFunctions.getMonthForSelect(selectedYear), 10);
        const currentSelMonth = parseInt(selectedMonth, 10);
        setUnlockedMonthLimit(Math.max(defaultLim, currentSelMonth));
    }, [selectedYear, selectedAccountant]);

    useEffect(() => {
        if (accountingSettlement?.statementFinished) {
            const finishedMonth = parseInt(accountingSettlement.month || selectedMonth, 10);
            const nextMonth = finishedMonth + 1;
            setUnlockedMonthLimit(prev => Math.max(prev, nextMonth));
        }
    }, [accountingSettlement, selectedMonth]);

    useEffect(() => {
        if (gridColumnApi) {
            gridColumnApi.setColumnsVisible(['salesTurnoverRange', 'costTurnoverRange'], canViewTurnover);
        }
    }, [gridColumnApi, canViewTurnover]);

    // Top Column Definitions
    const [columnDefs, setColumnDefs] = useState([
        {
            headerName: "Firma",
            field: "clientName",
            tooltipValueGetter: (params) => {
                switch (params.data?.vatStatus) {
                    case "CZYNNY": return "Status VAT klienta: Czynny";
                    case "ZWOLNIONY": return "Status VAT klienta: Zwolniony";
                    case "NIEZAREJESTROWANY": return "Status VAT klienta: Niezarejestrowany";
                    default: return "";
                }
            },
            cellRenderer: CompanyRenderer,
            editable: false,
            lockPosition: 'left',
            floatingFilter: false,
            filter: 'agTextColumnFilter',
            minWidth: 180,
        },
        {
            headerName: "NIP",
            field: "clientNIP",
            lockPosition: 'left',
            filter: 'agTextColumnFilter',
            editable: false,
            minWidth: 140,
            floatingFilter: false,
            cellRenderer: CopyableTextRenderer,
        },
        {
            headerName: "Dok. zaległe",
            field: "overdueDocumentsNumber",
            minWidth: 76,
            maxWidth: 76,
            filter: false,
            lockPosition: 'left',
            editable: false,
            headerClass: 'no-separator',
            headerTooltip: `Dokumenty dostarczone przez klienta po terminie.\nJeżeli niezbędne były korekty deklaracji - \nproszę doliczyć je w kolumnie "Dodatkowe usługi".`,
        },
        {
            headerName: "",
            field: "overdue",
            minWidth: 50,
            maxWidth: 50,
            lockPosition: 'left',
            filter: false,
            floatingFilter: false,
            sortable: false,
            editable: false,
            cellRenderer: BtnCellRenderer,
            cellRendererParams: {
                roles: roles,
                clicked: function (params) {
                    handleUpdateOverdueDocuments(params, true);
                },
            },
            cellStyle: {
                display: "flex",
                justifyContent: "center",
                alignItems: "center"
            },
            headerTooltip: `Dokumenty dostarczone przez klienta po terminie.\n\n
            Jeżeli niezbędne były korekty deklaracji - \nproszę doliczyć je w kolumnie "Dodatkowe usługi".`,
            headerComponentParams: {
                template:
                    `<div class="ag-cell-label-container" role="presentation">
                        <i class="fas fa-info-circle"></i>
                    </div>`
            },
        },
        {
            headerName: "Inne",
            field: "otherDocumentsNumber",
            minWidth: 61,
            maxWidth: 61,
            filter: false,
            lockPosition: 'left',
            editable: false,
            headerClass: 'no-separator',
            headerTooltip: "Bieżące dokumenty inne",
        },
        {
            headerName: "",
            field: "other",
            minWidth: 50,
            maxWidth: 50,
            lockPosition: 'left',
            filter: false,
            floatingFilter: false,
            sortable: false,
            editable: false,
            cellRenderer: BtnCellRenderer,
            cellRendererParams: {
                roles: roles,
                clicked: function (params) {
                    handleUpdateOtherDocuments(params);
                },
            },
            cellStyle: {
                display: "flex",
                justifyContent: "center",
                alignItems: "center"
            },
            headerTooltip: "Bieżące dokumenty inne",
            headerComponentParams: {
                template:
                    `<div class="ag-cell-label-container" role="presentation">
                        <i class="fas fa-info-circle"></i>
                    </div>`
            },
        },
        {
            headerName: "Obrót sprzedaż",
            field: "salesTurnoverRange",
            minWidth: 175,
            width: 175,
            lockPosition: 'left',
            filter: 'agTextColumnFilter',
            editable: false,
            cellRenderer: TurnoverCellRenderer,
            headerTooltip: "Przedział skumulowanej sprzedaży netto ze Scanye (wg poprzedniego miesiąca). Ostrzega o limitach VAT.",
            headerComponent: HeaderComponentForStatement,
            headerComponentParams: { text: "Obrót sprzedaż", iconClass: "fas fa-chart-line" },
            hide: !canViewTurnover,
        },
        {
            headerName: "Obrót koszty",
            field: "costTurnoverRange",
            minWidth: 145,
            lockPosition: 'left',
            filter: 'agTextColumnFilter',
            editable: false,
            cellRenderer: TurnoverCellRenderer,
            headerTooltip: "Przedział skumulowanych kosztów netto ze Scanye (wg poprzedniego miesiąca).",
            headerComponent: HeaderComponentForStatement,
            headerComponentParams: { text: "Obrót koszty", iconClass: "fas fa-receipt" },
            hide: !canViewTurnover,
        },
        {
            headerName: "Dokumenty sprzedażowe",
            field: "salesDocuments",
            minWidth: 70,
            lockPosition: 'left',
            filter: false,
            hide: false,
            headerTooltip: "Dokumenty sprzedażowe - bieżące dokumenty sprzedaży",
            headerComponent: HeaderComponentForStatement,
            headerComponentParams: { text: "Dok. sprzed.", iconClass: "fas fa-file-invoice-dollar" },
        },

        {
            headerName: "Dokumenty zakupowe",
            field: "purchaseDocuments",
            minWidth: 70,
            lockPosition: 'left',
            headerTooltip: "Dokumenty zakupowe - bieżące koszty",
            headerComponent: HeaderComponentForStatement,
            headerComponentParams: { text: "Dok. zakup.", iconClass: "fas fa-shopping-cart" },
        },
        {
            headerName: "Wyciągi bankowe",
            field: "bankStatements",
            minWidth: 70,
            lockPosition: 'left',
            headerTooltip: "Wyciągi bankowe (20 pozycji = 1 dokument)",
            headerComponent: HeaderComponentForStatement,
            headerComponentParams: { text: "Wyciągi bankowe", iconClass: "fas fa-money-check-alt" },
        },
        {
            headerName: "Łącznie dokumentów",
            field: "allDocuments",
            cellStyle: { fontWeight: "bold" },
            minWidth: 80,
            editable: false,
            lockPosition: 'left',
            headerComponent: HeaderComponent,
            headerComponentParams: { text: "Łącznie dokumentów", iconClass: "fas fa-layer-group" },
            headerTooltip: "Łącznie dokumentów",
            valueGetter: function (params) {
                const cn = params.data?.clientName;
                if (cn === "BONUS" || cn === "ANTYBONUS" || cn === "BONUS ŚWIĄTECZNY" || cn === "BLOKADA" || cn === "ZWROT BLOKADY" || cn === "DODATKOWA OPŁATA") {
                    return null;
                }
                return Number(params.data.salesDocuments) +
                    Number(params.data.purchaseDocuments) +
                    Number(params.data.bankStatements) + Number(params.data.otherDocumentsNumber) + Number(params.data.overdueDocumentsNumber)
            }, aggFunc: 'sum'
        },
        {
            headerName: "Umowa o pracę",
            field: "jobContracts",
            minWidth: 70,
            lockPosition: 'left',
            headerComponent: HeaderComponent,
            headerComponentParams: { text: "Umowa o pracę", iconClass: "fas fa-user-friends" },
            headerTooltip: "Umowa o pracę",
        },
        {
            headerName: "Umowa zlecenie/dzieło",
            field: "mandateContracts",
            minWidth: 70,
            lockPosition: 'left',
            headerComponent: HeaderComponent,
            headerComponentParams: { text: "Umowa zlecenie/dzieło", iconClass: "fas fa-handshake" },
            headerTooltip: "Umowa zlecenie/dzieło",
        },
        {
            headerName: "Członek zarządu z powołania/student do 26 r.",
            field: "appointedBoardMembers",
            minWidth: 70,
            lockPosition: 'left',
            headerComponent: HeaderComponentForStatement,
            headerComponentParams: { text: "Czł. zarządu", iconClass: "fas fa-user-tie" },
            headerTooltip: "Członek zarządu z powołania/student do 26 r.",
        },
        {
            headerName: "Kadry premium",
            field: "premiumPersonnel",
            minWidth: 70,
            lockPosition: 'left',
            headerComponent: HeaderComponentForStatement,
            headerComponentParams: { text: "Kadry premium", iconClass: "fas fa-gem" },
            headerTooltip: "Kadry premium",
        },
        {
            headerName: "Dodatkowe usługi",
            field: "additionalServicesNumber",
            minWidth: 70,
            maxWidth: 90,
            lockPosition: 'left',
            editable: false,
            headerClass: 'no-separator',
            headerComponent: HeaderComponent,
            headerComponentParams: { text: "Dodatkowe usługi", iconClass: "fas fa-plus-circle" },
            headerTooltip: "Dodatkowe usługi",
        },
        {
            headerName: "",
            field: "",
            colId: "additionalServicesAction",
            minWidth: 45,
            maxWidth: 45,
            lockPosition: 'left',
            floatingFilter: false,
            filter: false,
            sortable: false,
            editable: false,
            cellRenderer: BtnCellRenderer,
            cellStyle: {
                display: "flex",
                justifyContent: "center",
                alignItems: "center"
            },
            cellRendererParams: {
                roles: roles,
                clicked: function (params) {
                    handleUpdateAdditionalServicesDialog(params);
                },
            }
        },
        {
            headerName: "Cena netto",
            field: "netPrice",
            tooltipField: "tooltip",
            cellStyle: params => {
                const clientName = params.data?.clientName;
                if (clientName === "BONUS" || clientName === "BONUS ŚWIĄTECZNY" || clientName === "ZWROT BLOKADY") {
                    return { color: '#0daf0b', fontWeight: 'bold' };
                } else if (clientName === "ANTYBONUS" || clientName === "BLOKADA" || clientName === "DODATKOWA OPŁATA") {
                    return { color: 'red', fontWeight: 'bold' };
                }
                return { fontWeight: "bold" };
            },
            minWidth: 100,
            editable: false,
            lockPosition: 'left',
            valueFormatter: (params) => `${params.value} zł`,
        },
        {
            headerName: "Komentarz",
            field: "comment",
            cellEditor: 'agLargeTextCellEditor',
            cellEditorPopup: true,
            editable: (params) => params.data?.clientName !== "BONUS" && params.data?.clientName !== "ANTYBONUS" && params.data?.clientName !== "BONUS ŚWIĄTECZNY" && params.data?.clientName !== "BLOKADA" && params.data?.clientName !== "ZWROT BLOKADY" && params.data?.clientName !== "DODATKOWA OPŁATA",
            filter: 'agTextColumnFilter',
            cellEditorParams: { maxLength: 1990 },
            minWidth: 100,
            lockPosition: 'left',
            tooltipValueGetter: (params) => params.value || '',
            hide: !roles?.includes('ADMIN') && !roles?.includes('ADMIN_SUPERVISOR') && !roles?.includes('MANAGER') && !roles?.includes('SUPERVISOR') && !roles?.includes('SUPERVISOR_ACCOUNTANT')

        },
        {
            headerName: "Notatki",
            field: "notes",
            cellEditor: 'agLargeTextCellEditor',
            cellEditorPopup: true,
            editable: (params) => roles?.includes('ACCOUNTANT') && params.data?.clientName !== "BONUS" && params.data?.clientName !== "ANTYBONUS" && params.data?.clientName !== "BONUS ŚWIĄTECZNY" && params.data?.clientName !== "BLOKADA" && params.data?.clientName !== "ZWROT BLOKADY" && params.data?.clientName !== "DODATKOWA OPŁATA",
            filter: 'agTextColumnFilter',
            cellEditorParams: { maxLength: 1990 },
            minWidth: 100,
            lockPosition: 'left',
            headerClass: 'no-separator',
            tooltipValueGetter: (params) => params.value || '',
            hide: !roles?.includes('ADMIN') && !roles?.includes('ADMIN_SUPERVISOR') && !roles?.includes('MANAGER') && !roles?.includes('SUPERVISOR') && !roles?.includes('SUPERVISOR_ACCOUNTANT') && !roles?.includes('ACCOUNTANT')
        },
        {
            headerName: "Vatowiec?",
            field: "isClientVat",
            hide: true
        },
        {
            headerName: "Forma prawna",
            field: "legalFormTypeDesc",
            hide: true
        },
    ]);

    // Bottom Column Definitions
    const [bottomData, setBottomData] = useState([
        {
            clientName: 'Razem',
            salesDocuments: 0,
            salesTurnoverRange: '',
            purchaseDocuments: 0,
            costTurnoverRange: '',
            bankStatements: 0,
            overdueDocumentsNumber: 0,
            otherDocumentsNumber: 0,
            allDocuments: 0,
            jobContracts: 0,
            mandateContracts: 0,
            appointedBoardMembers: 0,
            premiumPersonnel: 0,
            additionalServicesNumber: 0,
            netPrice: 0,
            isBottomTable: true,
            action: null
        }
    ]);

    const updateBottomData = (rowData) => {
        // Tworzenie nowego obiektu podsumowania, zerując wartości
        const newBottomData = {
            clientName: `${activeClients.length} ${getFirmaWordForm(activeClients.length)} | Razem`,
            salesDocuments: 0,
            salesTurnoverRange: '',
            purchaseDocuments: 0,
            costTurnoverRange: '',
            bankStatements: 0,
            overdueDocumentsNumber: 0,
            otherDocumentsNumber: 0,
            allDocuments: 0,
            jobContracts: 0,
            mandateContracts: 0,
            appointedBoardMembers: 0,
            premiumPersonnel: 0,
            additionalServicesNumber: 0,
            netPrice: 0,
            isBottomTable: true
        };

        // Dodawanie wartości z każdego wiersza
        rowData.forEach((row) => {
            newBottomData.salesDocuments += Number(row.salesDocuments);
            newBottomData.purchaseDocuments += Number(row.purchaseDocuments);
            newBottomData.bankStatements += Number(row.bankStatements);
            newBottomData.overdueDocumentsNumber += Number(row.overdueDocumentsNumber);
            newBottomData.otherDocumentsNumber += Number(row.otherDocumentsNumber);
            newBottomData.allDocuments += Number(row.allDocuments);
            newBottomData.jobContracts += Number(row.jobContracts);
            newBottomData.mandateContracts += Number(row.mandateContracts);
            newBottomData.appointedBoardMembers += Number(row.appointedBoardMembers);
            newBottomData.premiumPersonnel += Number(row.premiumPersonnel);
            newBottomData.additionalServicesNumber += Number(row.additionalServicesNumber);
            newBottomData.netPrice += Number(row.netPrice);
        });

        // Aktualizacja stanu bottomData
        setBottomData([newBottomData]);
    };

    const getFirmaWordForm = (count) => {
        if (count === 1) return "firma";
        if (count % 10 >= 2 && count % 10 <= 4 && (count % 100 < 10 || count % 100 >= 20)) return "firmy";
        return "firm";
    };

    // Wywołanie funkcji po zmianie danych
    useEffect(() => {
        updateBottomData(tableData);
    }, [tableData]);

    // DefaultColDef sets props common to all Columns
    const defaultColDef = useMemo(() => ({
        sortable: true,
        resizable: true,
        filter: false,
        floatingFilter: false,
        flex: 1,
        filter: 'agNumberColumnFilter',
        tooltipComponent: CustomTooltip,
        editable: (params) => {
            const clientName = params.data?.clientName;
            if (clientName === "BONUS" || clientName === "ANTYBONUS" || clientName === "BONUS ŚWIĄTECZNY" || clientName === "BLOKADA" || clientName === "ZWROT BLOKADY" || clientName === "DODATKOWA OPŁATA") {
                return false;
            }
            return !accountingSettlement?.statementFinished && !roles?.includes('ACCOUNT_MANAGER') && !roles?.includes('SUPERVISOR') || (roles?.includes('SUPERVISOR_ACCOUNTANT') && contactId === selectedAccountant);
        },
    }));

    const bottomColDef = useMemo(() => ({
        resizable: false,
        flex: 1,
        editable: false,
    }));

    const mapToSelect = (item) => {
        return {
            id: item.id,
            title: item.surname + ' ' + item.name,
        };
    };

    const getRowId = useMemo(() => {
        return (params) => {
            return params.data.id;
        };
    }, []);

    const rowClassRules = useMemo(() => ({
        'vat-alert-exceeded-row': (params) => {
            return Boolean(canViewTurnover && params.data?.needsVatRegistration && params.data?.vatAlertStatus === 'EXCEEDED');
        },
        'vat-alert-approaching-row': (params) => {
            return Boolean(canViewTurnover && params.data?.needsVatRegistration && params.data?.vatAlertStatus === 'APPROACHING');
        }
    }), [canViewTurnover]);

    const [originalColumnDefs] = useState(columnDefs);
    const toggleMinWidth = () => {
        if (isModified) {
            setColumnDefs(originalColumnDefs); // Przywracanie oryginalnych wartości
        } else {
            setColumnDefs(columnDefs.map(colDef => {
                if (colDef.field === 'salesTurnoverRange') {
                    return { ...colDef, minWidth: 175 };
                }
                return colDef.field
                    ? { ...colDef, minWidth: 120 }
                    : colDef;
            }));
        }
        setIsModified(!isModified); // Zmiana stanu na przeciwny
    };


    const counter = useRef(0);
    // stara wersja
    const rowUpdatePromises = useRef({});

    const handleRowDataChange = (params) => {
        if (params.oldValue === params.newValue) {
            return;
        }

        const { data } = params;
        const rowId = data.id;
        let oldValue = params.oldValue;
        let newValue = params.newValue;

        const doUpdate = () => {
            const dataSnapshot = { ...data };
            return fetch(urlAccountingStatements + `/${rowId}`, {
                method: 'PUT',
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': `Bearer ${token}`
                },
                body: JSON.stringify(dataSnapshot),
            })
                .then((response) => {
                    if (!response.ok) {
                        throw new Error(`Błąd HTTP: ${response.status}`);
                    }
                    return response.json();
                })
                .then((responseData) => {
                    console.log('Aktualizowany rekord został wysłany do bazy danych:', responseData);

                    const rowNode = gridApi?.getRowNode(responseData.id.toString());

                    if (rowNode) {
                        Object.keys(responseData).forEach(key => {
                            if (rowNode.data[key] === dataSnapshot[key]) {
                                rowNode.data[key] = responseData[key];
                            }
                        });
                        gridApi.refreshCells({ rowNodes: [rowNode], columns: ['netPrice'], force: true });
                    }
                    updateBottomData(tableData);
                    const accountant = accountants.find(accountant => accountant.id === selectedAccountant);
                    if (accountant === undefined && params.colDef.field !== 'netPrice') {
                        logActivity(logActionType.STATEMENT_EDIT + userName + ", miesiąc: " + responseData.month + "/" + responseData.year + ", wiersz klienta: " + responseData.clientName + ", kolumna: " + params.colDef.headerName + ", stara wartość: " + oldValue + ", nowa wartość: " + newValue + ".", userName, token, contactId, responseData.month, responseData.year, isStatementEdited);
                    } else if (params.colDef.field !== 'netPrice') {
                        logActivity(logActionType.STATEMENT_EDIT + accountant.title + ", miesiąc: " + responseData.month + "/" + responseData.year + ", wiersz klienta: " + responseData.clientName + ", kolumna: " + params.colDef.headerName + ", stara wartość: " + oldValue + ", nowa wartość: " + newValue + ".", userName, token, accountant.id, responseData.month, responseData.year, isStatementEdited);
                    }
                });
        };

        const currentPromise = rowUpdatePromises.current[rowId] || Promise.resolve();

        rowUpdatePromises.current[rowId] = currentPromise
            .then(() => doUpdate())
            .catch((error) => {
                // Ignore errors from previous promises in the chain so this one can still run
                return doUpdate();
            })
            .catch((error) => {
                console.error('Błąd podczas wysyłania danych', error);
                CustomAlert('Błąd podczas wysyłania danych', 'Błąd', 'error');

                // Cofnięcie zmiany w tabeli bez pętli
                const rowNode = gridApi?.getRowNode(rowId.toString());
                if (rowNode && params.colDef.field) {
                    rowNode.data[params.colDef.field] = oldValue;
                    gridApi.refreshCells({ rowNodes: [rowNode], columns: [params.colDef.field], force: true });
                }
            });
    };

    const handleMonthChange = (event) => {
        const selectedValue = event.target.value;
        setIsTableLoading(true);
        setSelectedMonth(selectedValue);
        getDocumentType(selectedYear, selectedValue);
    };

    const handleYearChange = (event) => {
        const selectedValue = event.target.value;
        setIsTableLoading(true);
        setSelectedYear(selectedValue);
        getDocumentType(selectedValue, selectedMonth);
    };

    const handleAccountantChange = (event) => {
        const selectedValue = event.target.value;
        setIsTableLoading(true);
        setSelectedAccountant(selectedValue);
    };

    const handleCloseOtherDocuments = () => {
        setOpenOtherDocumentsDialog(false);
        setFormData([])
    };

    const handleUpdateOtherDocuments = (oldData) => {
        setFormData(oldData);
        setOldOtherDocuments(oldData.otherDocuments)
        setOpenOtherDocumentsDialog(true);
    }

    const handleCloseOverdueDocuments = () => {
        setOpenOverdueDocumentsDialog(false);
        setFormData([])
    };

    const handleUpdateOverdueDocuments = (oldData) => {
        setFormData(oldData);
        setOldOtherDocuments(oldData.otherDocuments)
        setOpenOverdueDocumentsDialog(true);
    }

    const handleCloseAdditionalServicesDialog = () => {
        setOpenAdditionalServicesDialog(false);
        setAdditionalServicesData([])
    };

    const handleUpdateAdditionalServicesDialog = (oldData) => {
        setAdditionalServicesData(oldData)
        setOldServices(oldData.additionalServices)
        setOpenAdditionalServicesDialog(true);
    }

    const onChangeAdditionalServices = (e) => {
        const { value, id } = e.target
        setAdditionalServicesData({ ...additionalServicesFormData, [id]: value })
    }

    const handleSubmitAdditionalServices = () => {
        if (additionalServicesFormData.id) {
            const dataToSend = {
                ...additionalServicesFormData,
                additionalServices:
                    additionalServicesFormData.additionalServices.map(service => ({
                        id: service.id,
                        serviceTypeId: service.serviceTypeId,
                        quantity: service.quantity,
                        serviceDetails: service.serviceDetails
                    }))
            }
            updateAccountingStatementForServices(urlAccountingStatements, additionalServicesFormData.id, dataToSend, oldServices, dataToSend.additionalServices);
        }
    }

    const handleSubmitOtherDocuments = (documents, isOverdue) => {
        if (formData.id) {
            const existingDocumentIds = formData.otherDocuments.map(doc => doc.id);

            const uniquePrevDocuments = documents.filter(prevDoc =>
                !existingDocumentIds.includes(prevDoc.id) // Sprawdzenie, czy dokument nie istnieje
            );

            const dataToSend = {
                ...formData,
                otherDocuments: [
                    ...formData.otherDocuments.map(doc => ({
                        id: doc.id || null,
                        documentTypeId: doc.documentTypeId,
                        accountingStatementId: doc.accountingStatementId,
                        quantity: doc.quantity,
                        comment: doc.comment || ""
                    })),
                    ...uniquePrevDocuments // Dodajemy tylko unikalne dokumenty
                ]
            };
            updateAccountingStatementForDocuments(urlAccountingStatements, formData.id, dataToSend, isOverdue, oldOtherDocuments, dataToSend.otherDocuments);
        }
    };

    const getDocumentTypeName = (id) => {
        const docType = documentType.find(doc => doc.key === id);
        return docType ? docType.value : id;
    };

    const getServiceTypeName = (id) => {
        const servType = serviceType.find(doc => doc.key === id);
        return servType ? servType.value : id;
    };


    const updateAccountingStatementForDocuments = (url, accountingStatementId, dataToSend, isOverdue, originalData, editedData) => {
        const { changes, added, removed } = compareDocumentsData(originalData, editedData);

        fetch(url + `/${accountingStatementId}`, {
            method: "PUT",
            body: JSON.stringify(dataToSend),
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${token}`
            }
        })
            .then(resp => resp.json())
            .then(resp => {
                handleCloseOtherDocuments();
                handleCloseOverdueDocuments();
                fetchAccountingStatements(selectedMonth, selectedYear, selectedAccountant);
                const accountant = accountants.find(accountant => accountant.id === selectedAccountant);
                const monthYear = `${resp.month}/${resp.year}`;
                const clientRow = `wiersz klienta: ${resp.clientName}`;
                const column = isOverdue ? "Dokumenty zaległe" : "Inne dokumenty";
                const accountantInfo = accountant ? accountant.title : userName;
                const accountantId = accountant ? accountant.id : contactId;

                let changeLog = "";
                if (added.length > 0) {
                    if (isOverdue) {
                        const doc171 = added.find(doc => doc.documentTypeId === 171);
                        const quantity171 = doc171 ? doc171.quantity : 0;
                        changeLog += `\n\nDodano dokumenty. Ilość: ${quantity171}`;
                    } else {
                        changeLog += "\n\nDodano dokumenty:\n";
                        changeLog += added.map(doc => `- ${getDocumentTypeName(doc.documentTypeId)} (ilość: ${doc.quantity})`).join("\n");
                    }
                }

                if (removed.length > 0) {
                    if (isOverdue) {
                        const doc171 = removed.find(doc => doc.documentTypeId === 171);
                        const quantity171 = doc171 ? doc171.quantity : 0;
                        changeLog += `\n\nUsunięto dokumenty: Ilość: ${quantity171}`;
                    } else {
                        changeLog += "\n\nUsunięto dokumenty:\n";
                        changeLog += removed.map(doc => `- ${getDocumentTypeName(doc.documentTypeId)}`).join("\n");
                    }
                }

                if (changes.length > 0) {
                    if (isOverdue) {
                        changes.forEach(change => {
                            if (change.before.quantity !== change.after.quantity) {
                                changeLog += `\n\n- Zmieniono liczbę: z ${change.before.quantity} na ${change.after.quantity}`;
                            }
                            if (change.before.comment !== change.after.comment) {
                                if (changes.length == 1) { changeLog += `\n` }
                                changeLog += `- Zmieniono komentarz: z "${change.before.comment}" na "${change.after.comment}"`;
                            }
                        });
                    } else {
                        changeLog += "\n\nZmieniono dokumenty:\n";
                        changeLog += changes.map(change => {
                            const before = change.before;
                            const after = change.after;
                            const diffs = [];

                            if (before.quantity !== after.quantity) {
                                diffs.push(`ilość: z ${before.quantity} na ${after.quantity}`);
                            }

                            if (before.documentTypeId !== after.documentTypeId) {
                                diffs.push(`zmiana nazwy na: ${getDocumentTypeName(after.documentTypeId)}`);
                            }

                            return `- ${getDocumentTypeName(before.documentTypeId)} → ${diffs.join(", ")}`;
                        }).join("\n");
                    }
                }


                if (added.length > 0 || removed.length > 0 || changes.length > 0) {
                    logActivity(
                        `${logActionType.STATEMENT_EDIT}${accountantInfo}, miesiąc: ${monthYear}, ${clientRow}, kolumna: ${column}.${changeLog}`,
                        userName,
                        token,
                        accountantId,
                        resp.month,
                        resp.year,
                        isStatementEdited
                    );
                }
            })
            .catch(error => {
                alert('Błąd podczas wysyłania danych');
            });
    };

    const updateAccountingStatementForServices = (
        url,
        accountingStatementId,
        dataToSend,
        originalData,
        editedData
    ) => {
        const { changes, added, removed } = compareAdditionalServices(originalData, editedData);

        fetch(`${url}/${accountingStatementId}`, {
            method: "PUT",
            body: JSON.stringify(dataToSend),
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${token}`
            }
        })
            .then(resp => resp.json())
            .then(resp => {
                handleCloseAdditionalServicesDialog();
                fetchAccountingStatements(selectedMonth, selectedYear, selectedAccountant);

                const accountant = accountants.find(accountant => accountant.id === selectedAccountant);
                const monthYear = `${resp.month}/${resp.year}`;
                const clientRow = `wiersz klienta: ${resp.clientName}`;
                const column = "Dodatkowe usługi";
                const accountantInfo = accountant ? accountant.title : userName;
                const accountantId = accountant ? accountant.id : contactId;

                let changeLog = "";

                if (added.length > 0) {
                    changeLog += "\n\nDodano usługi:\n";
                    changeLog += added.map(service => {
                        const base = `- ${getServiceTypeName(service.serviceTypeId)} (ilość: ${service.quantity}`;
                        const details = service.serviceTypeId === 41
                            ? `, Opis usługi: ${service.serviceDetails || "brak"}`
                            : '';
                        return `${base}${details})`;
                    }).join("\n");
                }

                if (removed.length > 0) {
                    changeLog += "\n\nUsunięto usługi:\n";
                    changeLog += removed.map(service => {
                        const base = `- ${getServiceTypeName(service.serviceTypeId)}`;
                        const details = service.serviceTypeId === 41
                            ? `, Opis usługi: ${service.serviceDetails || "brak"}`
                            : '';
                        return `${base}${details}`;
                    }).join("\n");
                }

                if (changes.length > 0) {
                    changeLog += "\n\nZmieniono usługi:\n";
                    changeLog += changes.map(change => {
                        const before = change.before;
                        const after = change.after;
                        const diffs = [];

                        if (before.quantity !== after.quantity) {
                            diffs.push(`ilość: z ${before.quantity} na ${after.quantity}`);
                        }

                        if (before.serviceDetails !== after.serviceDetails && before.serviceTypeId === 41) {
                            diffs.push(`Opis usługi: z "${before.serviceDetails || "brak"}" na "${after.serviceDetails || "brak"}"`);
                        }

                        if (before.serviceTypeId !== after.serviceTypeId) {
                            diffs.push(`zmiana nazwy na: ${getServiceTypeName(after.serviceTypeId)}`);
                        }

                        return `- ${getServiceTypeName(before.serviceTypeId)} → ${diffs.join(", ")}`;
                    }).join("\n");
                }

                if (added.length > 0 || removed.length > 0 || changes.length > 0) {
                    logActivity(
                        `${logActionType.STATEMENT_EDIT}${accountantInfo}, miesiąc: ${monthYear}, ${clientRow}, kolumna: ${column}.${changeLog}`,
                        userName,
                        token,
                        accountantId,
                        resp.month,
                        resp.year,
                        isStatementEdited
                    );
                }
            })
            .catch(error => {
                console.error('Błąd podczas zapisywania usług dodatkowych:', error);
            });
    };

    const compareDocumentsData = (originalData, editedData) => {
        const originalMap = new Map(originalData.map(item => [item.id, item]));
        const editedMap = new Map(editedData.map(item => [item.id, item]));

        const changes = [];
        const added = [];
        const removed = [];

        // Sprawdzenie zmian i usuniętych elementów
        originalData.forEach(item => {
            const editedItem = editedMap.get(item.id);

            if (!editedItem) {
                removed.push(item); // Element usunięty
            } else if (
                item.quantity !== editedItem.quantity ||
                item.comment !== editedItem.comment ||
                item.documentTypeId !== editedItem.documentTypeId
            ) {
                changes.push({ before: item, after: editedItem }); // Element zmieniony
            }
        });

        // Sprawdzenie dodanych elementów
        editedData.forEach(item => {
            if (!originalMap.has(item.id)) {
                added.push(item);
            }
        });

        return { changes, added, removed };
    };

    const compareAdditionalServices = (originalData, editedData) => {
        const originalMap = new Map(originalData.map(item => [item.id, item]));
        const editedMap = new Map(editedData.map(item => [item.id, item]));

        const changes = [];
        const added = [];
        const removed = [];

        // Sprawdzenie zmian i usuniętych elementów
        originalData.forEach(item => {
            const editedItem = editedMap.get(item.id);

            if (!editedItem) {
                removed.push(item); // Element usunięty
            } else if (
                item.quantity !== editedItem.quantity ||
                item.serviceDetails !== editedItem.serviceDetails ||
                item.serviceTypeId !== editedItem.serviceTypeId
            ) {
                changes.push({ before: item, after: editedItem }); // Element zmieniony
            }
        });

        // Sprawdzenie dodanych elementów
        editedData.forEach(item => {
            if (!originalMap.has(item.id)) {
                added.push(item);
            }
        });

        return { changes, added, removed };
    };

    const onChange = (e) => {
        const { value, id } = e.target
        setFormData({ ...formData, [id]: value })
    }


    const handleActionButtons = (isApproved, isFinished, accountingSettlementId, accountingSettlement, actionType) => {
        const dataToSend = { ...accountingSettlement };
        dataToSend.statementApproved = isApproved;
        dataToSend.statementFinished = isFinished;
        if (isApproved || isFinished) {
            dataToSend.salary = bottomData && bottomData[0]?.netPrice;
        }
        else {
            dataToSend.salary = 0;
        }
        updateAccountingSettlement(urlAccountingSettlement, accountingSettlementId, dataToSend, actionType);
    }

    const openApproveForPaymentDialog = () => {
        setOpenApprovePaymentDialog(true);
    }

    const closeApproveForPaymentDialog = () => {
        setOpenApprovePaymentDialog(false)
    }

    const handleApproveForPayment = () => {
        setOpenApprovePaymentDialog(false)
        const dataToSend = { ...accountingSettlement };
        dataToSend.approvalDate = CommonFunctions.getJavaLocalDate();
        dataToSend.statementApprovedBy = contactId;
        handleActionButtons(true, true, accountingSettlement?.id, dataToSend, "approveForPayment");
    }

    const handleOpenConfirmDialog = (title, message, actionType, isSimple) => {
        if (actionType === "saveAndSend") {
            handleConfirm(actionType);
        }
        fetchData(urlAccountingStatements + `/clients?accountantId=${selectedAccountant}&month=${selectedMonth}&year=${selectedYear}`, null, setClients, null, token);
        setOpenConfirmDialog(true);
        setIsSimple(isSimple);
        setConfirmDialogTitle(title);
        setConfirmDialogMessage(message);
        setActionType(actionType);
    }

    const handleCloseConfirmDialog = () => {
        setOpenConfirmDialog(false);
    };

    const handleConfirm = (actionType, additionalData = {}, files = []) => {
        setOpenConfirmDialog(false);

        // Prepare data to send
        const dataToSend = {
            ...accountingSettlement,
            ...(actionType === "sendDeclaration" && additionalData),
            finishDate: accountingSettlement.finishDate || CommonFunctions.getJavaLocalDate(),
        };
        dataToSend.actionType = actionType;

        if (actionType === "saveAndSend") {
            handleActionButtons(false, true, dataToSend.id, dataToSend, "saveAndSend");
        } else if (actionType === "unlock") {
            dataToSend.isEdited = true;
            dataToSend.isDeclarationSent = false;
            handleActionButtons(false, false, dataToSend.id, dataToSend, "unlock");
        } else if (actionType === "unlockDeclaration") {
            dataToSend.isDeclarationSent = false;
            handleActionButtons(
                dataToSend.statementApproved,
                dataToSend.statementFinished,
                dataToSend.id,
                dataToSend,
                "unlockDeclaration"
            );
        } else if (actionType === "sendDeclaration") {
            dataToSend.isDeclarationSent = true;
            handleActionButtons(false, true, dataToSend.id, dataToSend, "sendDeclaration");

            files.forEach((fileData) => {
                CommonFunctions.handleFileSubmit(fileData.file, dataToSend.id, fileData.fileType, MyCollections.fileAssignmentId.ACCOUNTING_SETTLEMENT, token);
            });
        }
    };

    const fetchTariffData = async (accountant, month, year) => {
        const url = urlAccountants + `/tariff?accountantId=${accountant}&month=${month}&year=${year}`;
        setUrl(url);
        try {
            const response = await fetch(url, { headers: { 'Authorization': `Bearer ${token}` } });
            const data = await response.json();
            setTariffData(data);
            return data;  // Zwracamy dane, aby móc je użyć później
        } catch (error) {
            console.error(error);
            return null;
        }
    };



    const fetchAccountingStatements = async (month, year, accountant) => {
        setIsTableLoading(true);
        const tariffDataLocal = await fetchTariffData(accountant, month, year);
        const settlementDataLocal = await fetchAccountingSettlement(month, year, accountant);

        // ZMIANA: unikamy cienia nazwy selectedMonth ze stanu
        const monthObj = MyCollections.getMonthCollection().find((item) => item.id === month);
        const monthParam = monthObj ? monthObj.id : '';

        const url = urlAccountingStatements + `/all?accountantId=${accountant}&month=${monthParam}&year=${year}`;
        setUrl(url);

        fetch(url, { headers: { 'Authorization': `Bearer ${token}` } })
            .then(response => {
                if (!response.ok) {
                    if (response.status === 404) {
                        setTableData([]);
                        setIsTableLoading(false);
                        throw new Error("Brak cennika księgowej/księgowego przypisanego dla danego miesiąca - sprawdź poprawność danych na karcie");
                    }
                    setIsTableLoading(false);
                    throw new Error("Wystąpił błąd podczas pobierania danych");
                }
                return response.json();
            })
            .then(data => {
                // DODANE: dopuszczaj “BONUS ŚWIĄTECZNY” wyłącznie dla miesiąca 11
                const allowXmasBonus = Number(month) === 11 && Number(year) === 2025;
                const filtered = data.filter(item =>
                    item.clientName !== "BONUS ŚWIĄTECZNY" || allowXmasBonus
                );

                const rowData = filtered.map(item => addTooltipField(item, tariffDataLocal, settlementDataLocal));
                setTableData(rowData);
                setIsTableLoading(false);
            })
            .catch(error => {
                setIsTableLoading(false);
                alert(error.message);
                console.error(error);
            });
    };

    const addTooltipField = (item, tariffDataLocal, settlementDataLocal) => {

        if (item.clientName === "BONUS") {
            return {
                ...item,
                tooltip: "Premia za wysłanie zestawienia do końca miesiąca"
            }
        }
        else if (item.clientName === "ANTYBONUS") {
            return {
                ...item,
                tooltip: "Potrącenie wynagrodzenia za wysłanie zestawienia po terminie"
            }
        }
        else if (item.clientName === "BONUS ŚWIĄTECZNY") {
            return {
                ...item,
                tooltip: "Premia świąteczna za wysłanie zestawienia do końca grudnia"
            }
        }
        else if (item.clientName === "BLOKADA") {
            return {
                ...item,
                tooltip: "Blokada wynagrodzenia"
            }
        }
        else if (item.clientName === "ZWROT BLOKADY") {
            return {
                ...item,
                tooltip: "Zwrot zablokowanego wynagrodzenia"
            }
        }
        else if (item.clientName === "DODATKOWA OPŁATA") {
            return {
                ...item,
                tooltip: "Dodatkowa opłata za ponowne sprawdzenie sprawozdania"
            }
        }
        else {
            const allDocuments = Number(item.salesDocuments) +
                Number(item.purchaseDocuments) +
                Number(item.bankStatements) +
                Number(item.otherDocumentsNumber) +
                Number(item.overdueDocumentsNumber);

            let tooltip = `Składowe ceny netto:\n`;

            if (item.legalFormTypeId === 1) {
                tooltip += `Opłata bazowa: ${tariffDataLocal?.ttariffEntity?.baseFeeJDG} zł`;
                if (allDocuments !== 0) {
                    tooltip += `+\nLiczba zaksięgowanych dokumentów: ${allDocuments} szt. x ${tariffDataLocal?.ttariffEntity?.documentJDG} zł stawka`;
                }
            }
            else {
                tooltip += `Opłata bazowa: ${tariffDataLocal?.ttariffEntity?.baseFeeSpZoo} zł`;

                if (allDocuments !== 0) {
                    tooltip += `+\nLiczba zaksięgowanych dokumentów: ${allDocuments} szt. x ${tariffDataLocal?.ttariffEntity?.documentSpZoo} zł stawka`;
                }
            }
            if (item.jobContracts !== 0) {
                tooltip += `+\nLiczba obsłużonych umów o pracę: ${item.jobContracts} szt. x ${tariffDataLocal?.ttariffEntity?.personelServiceEmployeeContract} zł stawka`;
            }

            if (item.mandateContracts !== 0) {
                tooltip += `+\nLiczba obsłużonych umów zlecenie/dzieło: ${item.mandateContracts} szt. x ${tariffDataLocal?.ttariffEntity?.personelServiceWork} zł stawka`;
            }

            if (item.appointedBoardMembers !== 0) {
                tooltip += `+\nLiczba obsłużonych członków zarządu z powołania: ${item.appointedBoardMembers} szt. x ${tariffDataLocal?.ttariffEntity?.personelServiceManagement} zł stawka`;
            }

            if (item.premiumPersonnel !== 0) {
                tooltip += `+\nLiczba obsłużonych pracowników w oparciu o usługę kadry Premium: ${item.premiumPersonnel} szt. x ${tariffDataLocal?.ttariffEntity?.premiumPersonnel} zł stawka`;
            }

            item.additionalServices?.map(item => {
                if (item.quantity !== 0) {
                    if (item.serviceTypeId === 1) {
                        tooltip += `+\nBilans i RZiS na żądanie klienta: ${item.quantity} szt. x ${tariffDataLocal?.ttariffEntity?.balanceSheetOnRequest} zł stawka`;
                    }
                    if (item.serviceTypeId === 11) {
                        tooltip += `+\nDodatkowe 2 godziny konsultacji: ${item.quantity} szt. x ${tariffDataLocal?.ttariffEntity?.additionalConsultation} zł stawka`;
                    }
                    if (item.serviceTypeId === 21) {
                        tooltip += `+\nDodatkowa deklaracja ponad standard: ${item.quantity} szt. x ${tariffDataLocal?.ttariffEntity?.additionalDeclaration} zł stawka`;
                    }
                    if (item.serviceTypeId === 31) {
                        tooltip += `+\nKorekta deklaracji podatkowej z winy klienta: ${item.quantity} szt. x ${tariffDataLocal?.ttariffEntity?.correctionOfDeclaration} zł stawka`;
                    }
                    if (item.serviceTypeId === 41) {
                        tooltip += `+\nUsługi niestandardowe: ${item.quantity} szt. x ${tariffDataLocal?.ttariffEntity?.otherServices} zł stawka`;
                    }
                    if (item.serviceTypeId === 51) {
                        tooltip += `+\nSprawozdanie finansowe mały klient: ${item.quantity} szt. x ${tariffDataLocal?.ttariffEntity?.finReportSmallClient} zł stawka`;
                    }
                    if (item.serviceTypeId === 61) {
                        tooltip += `+\nSprawozdanie finansowe średni klient: ${item.quantity} szt. x ${tariffDataLocal?.ttariffEntity?.finReportMediumClient} zł stawka`;
                    }
                    if (item.serviceTypeId === 71) {
                        tooltip += `+\nSprawozdanie finansowe duży klient: ${item.quantity} szt. x ${tariffDataLocal?.ttariffEntity?.finReportLargeClient} zł stawka`;
                    }
                    if (item.serviceTypeId === 81) {
                        tooltip += `+\nPomoc w złożeniu SF do eKRS: ${item.quantity} szt. x ${tariffDataLocal?.ttariffEntity?.sfToKrsAssistance} zł stawka`;
                    }
                    if (item.serviceTypeId === 91) {
                        tooltip += `+\nOpłata za CIT Estoński: ${item.quantity} szt. x ${tariffDataLocal?.ttariffEntity?.estonianCit} zł stawka`;
                    }
                }
            })

            return {
                ...item,
                isFinished: settlementDataLocal?.statementFinished,
                allDocuments: allDocuments,
                tooltip: tooltip.trim()
            };
        }
    };

    const clearFilters = useCallback(() => {
        const api = gridRef.current?.api;
        const columnApi = gridRef.current?.columnApi;

        if (api) {
            api.setFilterModel(null);

            if (api.applyColumnState) {
                api.applyColumnState({ defaultState: { sort: null } });
            } else if (columnApi && columnApi.applyColumnState) {
                columnApi.applyColumnState({ defaultState: { sort: null } });
            } else if (api.setSortModel) {
                api.setSortModel(null);
            }
        }
    }, []);

    const getDocumentType = (year, month) => {
        fetch(urlDocumentType + `/allForSelect?month=${month}&year=${year}`,
            {
                headers: { 'Authorization': `Bearer ${token}` }
            })
            .then(resp => resp.json())
            .then(data => {
                const rowData = data
                    .map(item => {
                        return {
                            key: item.id,
                            value: item.description,
                        };
                    });
                setDocumentType(rowData);
            })
            .catch(error => {
                console.error('Błąd pobierania danych:', error);
            });
    };


    const getServiceType = () => {
        fetch(urlServiceType + `/allForSelect?month=${selectedMonth}&year=${selectedYear}`, { headers: { 'Authorization': `Bearer ${token}` } })
            .then(resp => resp.json())
            .then(data => {
                const rowData = data.map(item => {
                    return {
                        key: item.id,
                        value: item.description,
                    };
                });
                setServiceType(rowData);
            })
            .catch(error => {
                console.error('Błąd pobierania danych:', error);
            });
    };

    const getStatementChangeLog = (accountantId, month, year) => {
        const params = new URLSearchParams({ accountantId, month, year });

        fetch(`${urlLogActivity}/statementChangeLog?${params.toString()}`, {
            headers: {
                'Authorization': `Bearer ${token}`,
                'Content-Type': 'application/json'
            }
        })
            .then(resp => {
                if (!resp.ok) {
                    throw new Error(`Błąd ${resp.status}: ${resp.statusText}`);
                }
                return resp.json();
            })
            .then(data => {
                const actionsList = data.length
                    ? data.map(item => item.action + ` \n\nCzas wykonania: ${item.timeStamp}`)
                    : ["Nie wykonano żadnych zmian..."];

                CustomAlert(actionsList, "Raport zmian wykonanych po ponownej edycji zestawienia:");
            })
            .catch(error => {
                console.error('Błąd pobierania danych:', error);
            });
    };

    const fetchAccountingSettlement = async (month, year, accountantId) => {
        const selectedMonth = MyCollections.getMonthCollection().find(
            (item) => item.id === month
        );

        const monthParam = selectedMonth ? selectedMonth.id : '';

        const url = urlAccountingSettlement + `/?accountantId=${accountantId}&month=${monthParam}&year=${year}`;
        setUrl(url);

        try {
            const response = await fetch(url, { headers: { 'Authorization': `Bearer ${token}` } });
            const data = await response.json();
            setAccountingSettlement(data);
            setIsStatementEdited(data.isEdited)
            setPopupEnabled(!data.statementFinished && !roles?.includes('ACCOUNT_MANAGER') && !roles?.includes('SUPERVISOR') || (roles?.includes('SUPERVISOR_ACCOUNTANT') && contactId === selectedAccountant));
            return data;
        } catch (error) {
            console.error(error);
            return null;
        }
    };



    const updateAccountingSettlement = (url, accountingSettlementId, dataToSend, actionType) => {
        fetch(url + `/${accountingSettlementId}`, {
            method: "PUT",
            body: JSON.stringify(dataToSend),
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${token}`
            }
        })
            .then(resp => resp.json())
            .then(data => {
                switch (actionType) {
                    case 'approveForPayment':
                        logActivity(logActionType.APPROVE_FOR_PAYMENT + data[0].accountantName + ", miesiąc: " + data[0].month + "/" + data[0].year, userName, token);
                        break;

                    case 'saveAndSend':
                        logActivity(logActionType.SAVE_AND_SEND_STATEMENT + data[0].accountantName + ", miesiąc: " + data[0].month + "/" + data[0].year, userName, token);
                        break;

                    case 'unlockDeclaration':
                        logActivity(logActionType.UNLOCK_INVOICE + data[0].accountantName + ", miesiąc: " + data[0].month + "/" + data[0].year, userName, token);
                        break;

                    case 'unlock':
                        logActivity(logActionType.UNLOCK_STATEMENT + data[0].accountantName + ", miesiąc: " + data[0].month + "/" + data[0].year, userName, token);
                        break;
                    default:
                        break;
                }
                fetchAccountingSettlement(selectedMonth, selectedYear, selectedAccountant);
                fetchAccountingStatements(selectedMonth, selectedYear, selectedAccountant);
            })
            .catch(error => {
                console.error('Błąd podczas wysyłania rekordu accountingSettlement:', error);
            });
    }


    const handleOpenAddBlockDialog = () => {
        if (accountingSettlement?.payed) {
            CustomAlert('Nie można dodać blokady dla opłaconego zestawienia.', 'Błąd', 'error');
            return;
        }
        setBlockAmount('');
        setBlockDescription('');
        setOpenAddBlockDialog(true);
    };

    const handleCloseAddBlockDialog = () => {
        setOpenAddBlockDialog(false);
    };

    const handlePreSubmitBlock = (e) => {
        e.preventDefault();
        if (!blockAmount || Number(blockAmount) <= 0) {
            CustomAlert('Proszę podać prawidłową kwotę blokady większą od zera.', 'Błąd', 'error');
            return;
        }
        if (!blockDescription.trim()) {
            CustomAlert('Proszę opisać warunek zdjęcia blokady.', 'Błąd', 'error');
            return;
        }
        setConfirmAddBlockOpen(true);
    };

    const handleConfirmAddBlock = () => {
        const payload = {
            accountantId: Number(selectedAccountant),
            amount: Number(blockAmount),
            description: blockDescription,
            statementMonth: Number(selectedMonth),
            statementYear: Number(selectedYear)
        };

        api.post('/salaryBlocks', payload)
            .then(() => {
                CustomAlert('Blokada wynagrodzenia została pomyślnie dodana.', 'Sukces', 'success');
                const accountant = accountants.find(acc => acc.id === Number(selectedAccountant));
                const targetAccountantName = accountant ? accountant.title : `ID: ${selectedAccountant}`;
                logActivity(
                    `${logActionType.SALARY_BLOCK_ADD}${targetAccountantName}, kwota: ${blockAmount} PLN, okres: ${String(selectedMonth).padStart(2, '0')}.${selectedYear}, warunek: ${blockDescription}`,
                    userName,
                    token,
                    Number(selectedAccountant),
                    Number(selectedMonth),
                    Number(selectedYear),
                    true
                );
                setConfirmAddBlockOpen(false);
                setOpenAddBlockDialog(false);
                fetchAccountingStatements(selectedMonth, selectedYear, selectedAccountant);
                fetchAccountingSettlement(selectedMonth, selectedYear, selectedAccountant);
            })
            .catch((err) => {
                console.error('Error adding salary block:', err);
                CustomAlert('Wystąpił błąd podczas dodawania blokady.', 'Błąd', 'error');
                setConfirmAddBlockOpen(false);
            });
    };

    const handleOpenAdditionalFeeDialog = () => {
        if (accountingSettlement?.payed) {
            CustomAlert('Nie można modyfikować opłaty dla opłaconego zestawienia.', 'Błąd', 'error');
            return;
        }
        const existingFeeRow = tableData.find(row => row.clientName === "DODATKOWA OPŁATA");
        if (existingFeeRow) {
            setAdditionalFeeAmount(Math.abs(existingFeeRow.netPrice).toString());
            setAdditionalFeeId(Math.abs(existingFeeRow.id + 30000));
        } else {
            setAdditionalFeeAmount('');
            setAdditionalFeeId(null);
        }
        setOpenAdditionalFeeDialog(true);
    };

    const handleCloseAdditionalFeeDialog = () => {
        setOpenAdditionalFeeDialog(false);
    };

    const handlePreSubmitAdditionalFee = (e) => {
        e.preventDefault();
        if (additionalFeeAmount === '' || Number(additionalFeeAmount) < 0) {
            CustomAlert('Proszę podać prawidłową kwotę opłaty (minimalnie 0).', 'Błąd', 'error');
            return;
        }
        setConfirmAdditionalFeeOpen(true);
    };

    const handleConfirmAdditionalFee = () => {
        const payload = {
            accountantId: Number(selectedAccountant),
            amount: Number(additionalFeeAmount),
            statementMonth: Number(selectedMonth),
            statementYear: Number(selectedYear)
        };

        let request;
        if (additionalFeeId) {
            if (Number(additionalFeeAmount) === 0) {
                request = api.delete(`/additionalFees/${additionalFeeId}`);
            } else {
                request = api.put(`/additionalFees/${additionalFeeId}`, payload);
            }
        } else {
            if (Number(additionalFeeAmount) === 0) {
                setConfirmAdditionalFeeOpen(false);
                setOpenAdditionalFeeDialog(false);
                return;
            }
            request = api.post('/additionalFees', payload);
        }

        request
            .then(() => {
                const isDelete = additionalFeeId && Number(additionalFeeAmount) === 0;
                CustomAlert(`Dodatkowa opłata została pomyślnie ${isDelete ? 'wycofana' : (additionalFeeId ? 'zaktualizowana' : 'dodana')}.`, 'Sukces', 'success');
                const accountant = accountants.find(acc => acc.id === Number(selectedAccountant));
                const targetAccountantName = accountant ? accountant.title : `ID: ${selectedAccountant}`;
                logActivity(
                    `${logActionType.STATEMENT_EDIT}${targetAccountantName}, kwota dodatkowej opłaty: ${additionalFeeAmount} PLN, okres: ${String(selectedMonth).padStart(2, '0')}.${selectedYear}`,
                    userName,
                    token,
                    Number(selectedAccountant),
                    Number(selectedMonth),
                    Number(selectedYear),
                    true
                );
                setConfirmAdditionalFeeOpen(false);
                setOpenAdditionalFeeDialog(false);
                fetchAccountingStatements(selectedMonth, selectedYear, selectedAccountant);
                fetchAccountingSettlement(selectedMonth, selectedYear, selectedAccountant);
            })
            .catch((err) => {
                console.error('Error saving additional fee:', err);
                CustomAlert('Wystąpił błąd podczas zapisywania dodatkowej opłaty.', 'Błąd', 'error');
                setConfirmAdditionalFeeOpen(false);
            });
    };


    const [syncingScanye, setSyncingScanye] = useState(false);

    const handleSyncScanyeTurnover = async () => {
        try {
            setSyncingScanye(true);
            await api.post(`/accountingStatements/turnover/sync?month=${selectedMonth}&year=${selectedYear}`);
            CustomAlert("Obroty firm ze Scanye zostały pomyślnie zsynchronizowane.", "Sukces", "success");
            await fetchAccountingStatements(selectedMonth, selectedYear, selectedAccountant);
        } catch (err) {
            console.error("Błąd synchronizacji Scanye:", err);
            const errorMsg = err.response?.data || err.message || "Błąd połączenia";
            CustomAlert("Nie udało się zsynchronizować obrotów ze Scanye: " + errorMsg, "Błąd", "error");
        } finally {
            setSyncingScanye(false);
        }
    };

    const onBtnExport = useCallback(() => {
        const turnoverCols = canViewTurnover ? ["salesTurnoverRange", "costTurnoverRange"] : [];
        const columnsToExport = [
            "clientName",
            "legalFormTypeDesc",
            "clientNIP",
            "isClientVat",
            ...turnoverCols,
            "overdueDocumentsNumber",
            "otherDocumentsNumber",
            "salesDocuments",
            "purchaseDocuments",
            "bankStatements",
            "allDocuments",
            "jobContracts",
            "mandateContracts",
            "appointedBoardMembers",
            "premiumPersonnel",
            "additionalServicesNumber",
            "netPrice"
        ];

        gridRef.current.api.exportDataAsCsv({
            columnKeys: columnsToExport,
        });
    }, [canViewTurnover]);


    return (
        <>
            <Paper className={classes.pageContent} elevation={0} >


                <Box
                    display="flex"
                    justifyContent="space-between"
                    alignItems="center"
                    flexWrap="wrap"
                    gap="12px"
                    sx={{ mb: 2, px: 2, pt: 2 }}
                >
                    {/* Lewa strona: Filtry daty i księgowej */}
                    <Box display="flex" alignItems="center" flexWrap="wrap" gap={1.5}>
                        <Box minWidth={110}>
                            <Controls.MySelect
                                name="monthId"
                                label="Miesiąc: "
                                value={selectedMonth}
                                onChange={handleMonthChange}
                                options={MyCollections.getMonthCollection(unlockedMonthLimit)}
                            />
                        </Box>
                        <Box minWidth={100}>
                            <Controls.MySelect
                                name="yearId"
                                label="Rok: "
                                value={selectedYear}
                                onChange={handleYearChange}
                                options={MyCollections.getYearCollection(
                                    2023,
                                    Math.max(
                                        parseInt(CommonFunctions.getYearForSelect(), 10),
                                        unlockedMonthLimit > 12 ? parseInt(selectedYear, 10) + 1 : parseInt(CommonFunctions.getYearForSelect(), 10)
                                    )
                                )}
                            />
                        </Box>
                        {roles?.includes('SUPERVISOR') || roles?.includes('SUPERVISOR_ACCOUNTANT') || roles?.includes('ADMIN') || roles?.includes('ADMIN_SUPERVISOR') || roles?.includes('ACCOUNT_MANAGER') || roles?.includes('MANAGER') ? (
                            <Box minWidth={180}>
                                <Controls.MySelect
                                    name="accountantId"
                                    label="Księgowa/y: "
                                    value={selectedAccountant}
                                    onChange={handleAccountantChange}
                                    options={accountants}
                                />
                            </Box>
                        ) : null}
                    </Box>

                    {/* Prawa strona: Przyciski akcji */}
                    <Box display="flex" alignItems="center" flexWrap="wrap" gap="8px">
                        {(roles?.includes('ADMIN') || roles?.includes('ADMIN_SUPERVISOR') || roles?.includes('MANAGER')) && (
                            <Controls.PremiumButton
                                variant="glass"
                                label="CSV"
                                onClick={onBtnExport}
                                icon="fas fa-download"
                            />
                        )}

                        <Controls.PremiumButton
                            variant="glass"
                            label="Wyczyść"
                            onClick={clearFilters}
                            icon="fas fa-filter"
                        />
                        <Controls.PremiumButton
                            variant="glass"
                            label={isModified ? "Minimalna szerokość kolumn" : "Optymalna szerokość kolumn"}
                            onClick={toggleMinWidth}
                            icon="fas fa-arrows-alt-h"
                        />
                        {canViewTurnover && (
                            <Controls.PremiumButton
                                variant="glass"
                                label={syncingScanye ? "Synchronizuję obroty..." : "Obroty Scanye"}
                                onClick={handleSyncScanyeTurnover}
                                disabled={syncingScanye}
                                icon={syncingScanye ? "fas fa-spinner fa-spin" : "fas fa-sync"}
                            />
                        )}
                        <ActionButtons
                            roles={roles}
                            isDesktop={isDesktop}
                            accountingSettlement={accountingSettlement}
                            activeClients={activeClients}
                            selectedAccountant={selectedAccountant}
                            contactId={contactId}
                            handleOpenConfirmDialog={handleOpenConfirmDialog}
                            openApproveForPaymentDialog={openApproveForPaymentDialog}
                            canAddBlock={canAddBlock}
                            handleOpenAddBlockDialog={handleOpenAddBlockDialog}
                            canAddAdditionalFee={canAddAdditionalFee}
                            handleOpenAdditionalFeeDialog={handleOpenAdditionalFeeDialog}
                            isStatementEdited={isStatementEdited}
                            getStatementChangeLog={getStatementChangeLog}
                            selectedMonth={selectedMonth}
                            selectedYear={selectedYear}
                        />
                    </Box>
                </Box>
                <Grid container rowSpacing={1} spacing={{ xs: 2, md: 4 }} columns={{ xs: 2, sm: 6, md: 12 }}>
                    <Grid item xs={12}>
                        <div className="App">
                            <div className="tableData">
                                {/* On div wrapping Grid a) specify theme CSS Class Class and b) sets Grid size */}
                                <div
                                    className={darkTheme ? 'ag-theme-balham-dark' : 'ag-theme-balham'}
                                    style={{ marginLeft: 0, marginRight: 0, height: 650 }}
                                >
                                    <div style={{ display: 'flex', flexDirection: 'column', height: '100%' }}>
                                        <div style={{ flex: '1 1 auto', minHeight: 0 }}>
                                            <AgGridReact context={{ darkTheme }}
                                                key={darkTheme ? 'grid-dark' : 'grid-light'}
                                                onGridReady={onGridReady}
                                                ref={gridRef}
                                                alignedGrids={bottomGrid.current ? [bottomGrid.current] : undefined}
                                                rowData={tableData}
                                                suppressHorizontalScroll
                                                columnDefs={columnDefs}
                                                rowClassRules={rowClassRules}
                                                defaultColDef={defaultColDef}
                                                animateRows={true}
                                                undoRedoCellEditing={undoRedoCellEditing}
                                                undoRedoCellEditingLimit={undoRedoCellEditingLimit}
                                                rowSelection='multiple'
                                                enableBrowserTooltips={false}
                                                suppressSizeToFit={true}
                                                onCellValueChanged={handleRowDataChange}
                                                suppressBrowserResizeObserver={true}
                                                getRowId={getRowId}
                                                headerHeight={70}
                                                rowHeight={26}
                                                localeText={MyCollections.localeTextPL}
                                                tooltipShowDelay={0}
                                                popupParent={document.body}
                                                overlayLoadingTemplate={'<span class="ag-overlay-loading-center">Ładowanie danych...</span>'}
                                                overlayNoRowsTemplate={'<span class="ag-overlay-loading-center">Ładowanie danych...</span>'}
                                            />
                                        </div>
                                        <Box sx={{ m: '10px' }} />
                                        <div style={{ flex: '0 0 auto' }}>
                                            <AgGridReact
                                                ref={bottomGrid}
                                                domLayout='autoHeight'
                                                alignedGrids={gridRef.current ? [gridRef.current] : undefined}
                                                defaultColDef={bottomColDef}
                                                columnDefs={columnDefs}
                                                rowData={bottomData}
                                                headerHeight={0}
                                                rowStyle={{ fontWeight: 'bold' }}
                                                suppressSizeToFit={true}
                                                supressVerticalScroll
                                                suppressBrowserResizeObserver={true}
                                                popupParent={document.body}
                                            />
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <ApproveForPaymentDialog open={openApprovePaymentDialog} handleClose={closeApproveForPaymentDialog} handleApproveForPayment={handleApproveForPayment} month={selectedMonth} year={selectedYear} accountantName={accountingSettlement?.accountantName} supervisorName={userName} date={currentDate} netPriceSummary={bottomData && bottomData[0]?.netPrice} />
                            <OtherDocumentsDialog open={openOtherDocumentsDialog} handleClose={handleCloseOtherDocuments} setFormData={setFormData}
                                formData={formData} onChange={onChange} handleFormSubmit={handleSubmitOtherDocuments} documentType={documentType} enabled={popupEnabled} />
                            <OverdueDocumentsDialog open={openOverdueDocumentsDialog} handleClose={handleCloseOverdueDocuments} setFormData={setFormData}
                                formData={formData} onChange={onChange} handleFormSubmit={handleSubmitOtherDocuments} enabled={popupEnabled} />
                            <AdditionalServicesDialog open={openAdditionalServicesDialog} handleClose={handleCloseAdditionalServicesDialog} setFormData={setAdditionalServicesData}
                                formData={additionalServicesFormData} onChange={onChangeAdditionalServices} handleFormSubmit={handleSubmitAdditionalServices} serviceType={serviceType} enabled={popupEnabled} />
                            <ConfirmDialog open={openConfirmDialog} handleClose={handleCloseConfirmDialog} handleConfirm={handleConfirm} title={confirmDialogTitle}
                                message={confirmDialogMessage} actionType={actionType} isSimple={isSimple} netPrice={bottomData?.[0]?.netPrice} date={currentDate} month={selectedMonth} year={selectedYear} clients={clients} />

                            {/* Dialog: Dodawanie blokady */}
                            <Dialog
                                open={openAddBlockDialog}
                                onClose={handleCloseAddBlockDialog}
                                fullWidth
                                maxWidth="sm"
                                PaperProps={{
                                    style: {
                                        backgroundColor: darkTheme ? '#1e1e1e' : '#ffffff',
                                        color: darkTheme ? '#ffffff' : '#333333',
                                        borderRadius: '12px'
                                    },
                                }}
                            >
                                <DialogTitle style={{ fontWeight: 'bold', borderBottom: `1px solid ${darkTheme ? '#333' : '#eee'}`, padding: '16px 24px' }}>
                                    Dodaj blokadę wynagrodzenia
                                </DialogTitle>
                                <form onSubmit={handlePreSubmitBlock}>
                                    <DialogContent style={{ padding: '24px' }}>
                                        <Box display="flex" flexDirection="column" gap="16px">
                                            <TextField
                                                label="Księgowa/y"
                                                value={accountingSettlement?.accountantName || ''}
                                                InputProps={{ readOnly: true }}
                                                variant="outlined"
                                                fullWidth
                                                size="small"
                                                disabled
                                            />
                                            <TextField
                                                label="Okres zestawienia"
                                                value={`Zestawienie ${String(selectedMonth).padStart(2, '0')}.${selectedYear}`}
                                                InputProps={{ readOnly: true }}
                                                variant="outlined"
                                                fullWidth
                                                size="small"
                                                disabled
                                            />
                                            <TextField
                                                label="Osoba nakładająca"
                                                value={userName || ''}
                                                InputProps={{ readOnly: true }}
                                                variant="outlined"
                                                fullWidth
                                                size="small"
                                                disabled
                                            />
                                            <TextField
                                                label="Kwota blokady netto (PLN)"
                                                type="number"
                                                value={blockAmount}
                                                onChange={(e) => setBlockAmount(e.target.value)}
                                                required
                                                variant="outlined"
                                                fullWidth
                                                size="small"
                                                inputProps={{ step: "0.01", min: "0.01" }}
                                                autoFocus
                                            />
                                            <TextField
                                                label="Warunek zdjęcia blokady / opis wymaganych działań"
                                                multiline
                                                rows={4}
                                                value={blockDescription}
                                                onChange={(e) => setBlockDescription(e.target.value)}
                                                required
                                                variant="outlined"
                                                fullWidth
                                                size="small"
                                            />
                                        </Box>
                                    </DialogContent>
                                    <DialogActions style={{ padding: '16px 24px', borderTop: `1px solid ${darkTheme ? '#333' : '#eee'}` }}>
                                        <Button onClick={handleCloseAddBlockDialog} style={{ color: '#888888', fontWeight: 'bold' }}>
                                            Anuluj
                                        </Button>
                                        <Button type="submit" variant="contained" color="error" style={{ fontWeight: 'bold' }}>
                                            Dodaj blokadę
                                        </Button>
                                    </DialogActions>
                                </form>
                            </Dialog>

                            {/* Dialog: Potwierdzenie dodania blokady */}
                            <Dialog
                                open={confirmAddBlockOpen}
                                onClose={() => setConfirmAddBlockOpen(false)}
                                PaperProps={{
                                    style: {
                                        backgroundColor: darkTheme ? '#1e1e1e' : '#ffffff',
                                        color: darkTheme ? '#ffffff' : '#333333',
                                    },
                                }}
                            >
                                <DialogTitle style={{ fontWeight: 'bold' }}>
                                    Potwierdź dodanie blokady
                                </DialogTitle>
                                <DialogContent>
                                    <DialogContentText style={{ color: darkTheme ? '#cccccc' : '#666666' }}>
                                        Czy na pewno chcesz zapisać blokadę wynagrodzenia w kwocie <strong>{Number(blockAmount).toFixed(2)} PLN</strong> dla księgowej/ego <strong>{accountingSettlement?.accountantName}</strong>?<br /><br />
                                        Kwota ta pomniejszy wypłatę w bieżącym okresie.
                                    </DialogContentText>
                                </DialogContent>
                                <DialogActions style={{ padding: '16px 24px' }}>
                                    <Button onClick={() => setConfirmAddBlockOpen(false)} style={{ color: '#888888', fontWeight: 'bold' }}>
                                        Zrezygnuj
                                    </Button>
                                    <Button onClick={handleConfirmAddBlock} style={{ color: '#d32f2f', fontWeight: 'bold' }}>
                                        Potwierdź
                                    </Button>
                                </DialogActions>
                            </Dialog>

                            {/* Dialog: Dodawanie/edycja dodatkowej opłaty */}
                            <Dialog
                                open={openAdditionalFeeDialog}
                                onClose={handleCloseAdditionalFeeDialog}
                                fullWidth
                                maxWidth="sm"
                                PaperProps={{
                                    style: {
                                        backgroundColor: darkTheme ? '#1e1e1e' : '#ffffff',
                                        color: darkTheme ? '#ffffff' : '#333333',
                                        borderRadius: '12px'
                                    },
                                }}
                            >
                                <DialogTitle style={{ fontWeight: 'bold', borderBottom: `1px solid ${darkTheme ? '#333' : '#eee'}`, padding: '16px 24px' }}>
                                    {additionalFeeId ? 'Edytuj dodatkową opłatę' : 'Dodaj dodatkową opłatę'}
                                </DialogTitle>
                                <form onSubmit={handlePreSubmitAdditionalFee}>
                                    <DialogContent style={{ padding: '24px' }}>
                                        <Box display="flex" flexDirection="column" gap="16px">
                                            <TextField
                                                label="Księgowa/y"
                                                value={accountingSettlement?.accountantName || ''}
                                                InputProps={{ readOnly: true }}
                                                variant="outlined"
                                                fullWidth
                                                size="small"
                                                disabled
                                            />
                                            <TextField
                                                label="Okres zestawienia"
                                                value={`Zestawienie ${String(selectedMonth).padStart(2, '0')}.${selectedYear}`}
                                                InputProps={{ readOnly: true }}
                                                variant="outlined"
                                                fullWidth
                                                size="small"
                                                disabled
                                            />
                                            <TextField
                                                label="Kwota opłaty netto (PLN)"
                                                type="number"
                                                value={additionalFeeAmount}
                                                onChange={(e) => setAdditionalFeeAmount(e.target.value)}
                                                required
                                                variant="outlined"
                                                fullWidth
                                                size="small"
                                                inputProps={{ step: "0.01", min: "0" }}
                                                autoFocus
                                            />
                                        </Box>
                                    </DialogContent>
                                    <DialogActions style={{ padding: '16px 24px', borderTop: `1px solid ${darkTheme ? '#333' : '#eee'}` }}>
                                        <Button onClick={handleCloseAdditionalFeeDialog} style={{ color: '#888888', fontWeight: 'bold' }}>
                                            Anuluj
                                        </Button>
                                        <Button type="submit" variant="contained" color="error" style={{ fontWeight: 'bold' }}>
                                            {additionalFeeId ? 'Zapisz' : 'Dodaj'}
                                        </Button>
                                    </DialogActions>
                                </form>
                            </Dialog>

                            {/* Dialog: Potwierdzenie dodania dodatkowej opłaty */}
                            <Dialog
                                open={confirmAdditionalFeeOpen}
                                onClose={() => setConfirmAdditionalFeeOpen(false)}
                                PaperProps={{
                                    style: {
                                        backgroundColor: darkTheme ? '#1e1e1e' : '#ffffff',
                                        color: darkTheme ? '#ffffff' : '#333333',
                                    },
                                }}
                            >
                                <DialogTitle style={{ fontWeight: 'bold' }}>
                                    Potwierdź dodatkową opłatę
                                </DialogTitle>
                                <DialogContent>
                                    <DialogContentText style={{ color: darkTheme ? '#cccccc' : '#666666' }}>
                                        {Number(additionalFeeAmount) === 0 ? (
                                            <>Czy na pewno chcesz <strong>wycofać</strong> dodatkową opłatę dla księgowej/ego <strong>{accountingSettlement?.accountantName}</strong>?</>
                                        ) : (
                                            <>
                                                Czy na pewno chcesz zapisać dodatkową opłatę w kwocie <strong>{Number(additionalFeeAmount).toFixed(2)} PLN</strong> dla księgowej/ego <strong>{accountingSettlement?.accountantName}</strong>?<br /><br />
                                                Kwota ta pomniejszy wypłatę w bieżącym okresie.
                                            </>
                                        )}
                                    </DialogContentText>
                                </DialogContent>
                                <DialogActions style={{ padding: '16px 24px' }}>
                                    <Button onClick={() => setConfirmAdditionalFeeOpen(false)} style={{ color: '#888888', fontWeight: 'bold' }}>
                                        Zrezygnuj
                                    </Button>
                                    <Button onClick={handleConfirmAdditionalFee} style={{ color: '#d32f2f', fontWeight: 'bold' }}>
                                        Potwierdź
                                    </Button>
                                </DialogActions>
                            </Dialog>

                        </div>
                    </Grid>
                </Grid>
                <Box sx={{ m: '20px' }} />
                <Grid container rowSpacing={1} spacing={{ xs: 2, md: 4 }} columns={{ xs: 2, sm: 6, md: 12 }}>
                    <Grid item xs={12}>
                        <p style={{ marginLeft: 12 }}><i>Każde 20 pozycji wyciagu bankowego = 1 dokument. Czyli np. jeżeli jest 40 pozycji na wyciagu, to zaznaczamy w polu „wyciągi bankowe” 2 sztuki</i></p>
                    </Grid>
                </Grid>
                <Box sx={{ m: '20px' }} />
                <Grid container rowSpacing={1} spacing={{ xs: 2, md: 4 }} columns={{ xs: 2, sm: 6, md: 12 }}>
                    <Grid item xs={12}>
                        <Accordion defaultExpanded>
                            <AccordionSummary
                                expandIcon={<ExpandMoreIcon />}
                                aria-controls="panel1a-content"
                                id="panel1a-header"
                            >
                                <Typography sx={{ fontWeight: 'bold' }}>Stawki netto:</Typography>
                            </AccordionSummary>
                            <AccordionDetails>
                                <Grid container spacing={2}>
                                    {tariffData && tariffData.ttariffEntity && tariffData.ttariffEntity.id ? (
                                        <Grid item container xs={12} key={tariffData.id}>
                                            <Grid item xs={1}>
                                                <Typography>
                                                    <div>
                                                        {tariffData.ttariffEntity.baseFeeSpZoo} zł
                                                    </div>
                                                    <div>
                                                        {tariffData.ttariffEntity.baseFeeJDG} zł
                                                    </div>
                                                    <div>
                                                        {tariffData.ttariffEntity.documentSpZoo} zł
                                                    </div>
                                                    <div>
                                                        {tariffData.ttariffEntity.documentJDG} zł
                                                    </div>
                                                    <Box sx={{ m: '20px' }} />
                                                    <div>
                                                        {tariffData.ttariffEntity.personelServiceManagement} zł
                                                    </div>
                                                    <div>
                                                        {tariffData.ttariffEntity.personelServiceWork} zł
                                                    </div>
                                                    <div>
                                                        {tariffData.ttariffEntity.personelServiceEmployeeContract} zł
                                                    </div>
                                                    <div>
                                                        {tariffData.ttariffEntity.premiumPersonnel} zł
                                                    </div>
                                                    <Box sx={{ m: '20px' }} />
                                                    <div>
                                                        {tariffData.ttariffEntity.additionalDeclaration} zł
                                                    </div>
                                                    <div>
                                                        {tariffData.ttariffEntity.correctionOfDeclaration} zł
                                                    </div>
                                                </Typography>
                                            </Grid>
                                            <Grid item xs={11}>
                                                <Typography>
                                                    <div>
                                                        Opłata bazowa za prowadzenie ksiąg Sp z o.o.
                                                    </div>
                                                    <div>
                                                        Opłata bazowa za prowadzenie ksiąg JDG
                                                    </div>
                                                    <div>
                                                        Każdy zaksięgowany dokument Sp z o.o.
                                                    </div>
                                                    <div>
                                                        Każdy zaksięgowany dokument JDG
                                                    </div>
                                                    <Box sx={{ m: '20px' }} />
                                                    <div>
                                                        Obsługa kadrowa członka zarządu z powołania / student poniżej 26 r. / wynagrodzenie z art. 176 ksh
                                                    </div>
                                                    <div>
                                                        Obsługa kadrowa pracownika zatrudnionego na umowę zlecenie lub o dzieło
                                                    </div>
                                                    <div>
                                                        Obsługa kadrowa pracownika zatrudnionego na umowę o pracę
                                                    </div>
                                                    <div>
                                                        Obsługa kadrowa Premium pracownika zatrudnionego na umowę o pracę - pełne prowadzenie teczki
                                                    </div>
                                                    <Box sx={{ m: '20px' }} />
                                                    <div>
                                                        Dodatkowa deklaracja ponad standard. Cena dla klienta to 45 zł
                                                    </div>
                                                    <div>
                                                        Korekta deklaracji podatkowej z winy klienta. Cena dla klienta to 100 zł
                                                    </div>
                                                </Typography>
                                            </Grid>
                                        </Grid>
                                    ) : (
                                        <Grid item xs={12}>
                                            <Typography>No data available.</Typography>
                                        </Grid>
                                    )}
                                </Grid>
                            </AccordionDetails>
                        </Accordion>
                        <Accordion defaultExpanded>
                            <AccordionSummary
                                expandIcon={<ExpandMoreIcon />}
                                aria-controls="panel2a-content"
                                id="panel2a-header"
                            >
                                <Typography sx={{ fontWeight: 'bold' }}>Usługi, które księgowa/y może dodatkowo sprzedać klientowi w imieniu 7PM: </Typography>

                            </AccordionSummary>
                            <AccordionDetails>
                                <Grid container spacing={2}>
                                    {tariffData && tariffData.ttariffEntity && tariffData.ttariffEntity.id ? (
                                        <Grid item container xs={12} key={tariffData.id}>
                                            <Grid item xs={1}>
                                                <Typography>
                                                    <div>
                                                        {tariffData.ttariffEntity.balanceSheetOnRequest} zł
                                                    </div>
                                                    <div>
                                                        {tariffData.ttariffEntity.additionalConsultation} zł
                                                    </div>
                                                    <div>
                                                        {tariffData.ttariffEntity.sfToKrsAssistance} zł
                                                    </div>
                                                    <div>
                                                        {tariffData.ttariffEntity.otherServices} zł
                                                    </div>
                                                    <div>
                                                        {tariffData.ttariffEntity.estonianCit} zł
                                                    </div>
                                                </Typography>
                                            </Grid>
                                            <Grid item xs={11}>
                                                <Typography>
                                                    <div>
                                                        Bilans i RZiS na żądanie klienta (za okres nie dłuższy niż 6 miesięcy). Cena dla klienta to 350 zł
                                                    </div>
                                                    <div>
                                                        Dodatkowe 2 godziny konsultacji - jeżeli klient potrzebuje dużo rozmawiać. Cena dla klienta to 250 zł
                                                    </div>
                                                    <div>
                                                        Pomoc w złożeniu SF do eKRS. Cena dla klienta to 250 zł
                                                    </div>
                                                    <div>
                                                        Dowolne inne usługi dodatkowe wykraczające poza standard. Cena dla klienta 80 zł
                                                    </div>
                                                    <div>
                                                        Opłata za CIT estoński. Cena dla klienta 150 zł
                                                    </div>
                                                </Typography>
                                            </Grid>
                                        </Grid>
                                    ) : (
                                        <Grid item xs={12}>
                                            <Typography>No data available.</Typography>
                                        </Grid>
                                    )}
                                </Grid>
                                <Grid container spacing={2}>
                                    <Grid item xs={12}>
                                        <div style={{ marginTop: 35 }}>
                                            <div><i>W każdej tego typu sytuacji, księgowa/y powinna/ien otrzymać od klienta mailowe potwierdzenie, wystarczy jedno zdanie Np. "Potwierdzam zamówienie: bilans i RziS w cenie 350 PLN netto".
                                                Usługi ponad standard, ale o mniejszej wartości niż 50 zł, proszę wpisywać jako dodatkowe dokumenty "inne" z wyjaśnieniem o co chodzi</i></div>
                                        </div>
                                    </Grid>
                                </Grid>
                            </AccordionDetails>
                        </Accordion>
                    </Grid>
                </Grid>
            </Paper >
        </>
    );
};

export default MonthlyStatement;